import { DataOperation } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/server-connector";

import { TextbausteinData } from "../../app/slices/fachverfahren/types";
import { DocumentReference } from "../../utilities/documentReference";
import { TEXTBAUSTEINE_VERFAHREN_DOCUMENT } from "../../utilities/variables/documentModelName";

/**
 * Gemeinsame Schnittstelle für Manifeste, die Textbaustein-Daten unterstützen.
 * Wird sowohl von RuntimeFachverfahrenManifest als auch von RuntimeStammdatenManifest erfüllt.
 */
export interface RuntimeManifestWithTextbaustein {
	readonly identification: {
		readonly key: string;
		readonly version: number;
		readonly id: string;
		readonly shortName: string;
		readonly longName: string;
	};
	readonly documentReference: DocumentReference;
	readonly textbausteinData?: TextbausteinData;
}

/**
 * Erstellt eine virtuelle docRef eines virtuellen Dokuments.
 * Sie ist immer vom Typ "Verfahren_D" und als ID wird die ID von der Dokumentenreferenz des Manifests verwendet.
 * Funktioniert sowohl für Fachverfahren- als auch für Stammdaten-Manifeste.
 * @param manifest
 * @returns
 */
export function getVirtualVerfahrenDocRef(manifest: RuntimeManifestWithTextbaustein): string {
	return TEXTBAUSTEINE_VERFAHREN_DOCUMENT + "/" + manifest.documentReference.id;
}

export interface QueryWithSource extends DataOperation.Query.BaseQuery {
	source: string;
}

export function isQueryWithSource(query: DataOperation.Query): query is QueryWithSource {
	return DataOperation.Query.BaseQuery.isAssignableFrom(query) && "source" in query;
}
